import { createReducer } from '../utils';
import { SOCKET_EMIT } from '../middleware/socket';

const initialState = {
  connected: false,
  rooms: [],
};

/* ACTIONS */
const SOCKET_CONNECTED = 'socket/CONNECTED';
const SOCKET_DISCONNECTED = 'socket/DISCONNECTED';
const SOCKET_JOIN_ROOM = 'socket/JOIN_ROOM';
const SOCKET_LEAVE_ROOM = 'socket/LEAVE_ROOM';

export function socketConnected() {
  return { type: SOCKET_CONNECTED };
};

export function socketDisconnected() {
  return { type: SOCKET_DISCONNECTED };
};

export function emit(payload) {
  return { type: SOCKET_EMIT, payload };
};

export function join(token, room) {
  return (dispatch) => {
    dispatch(emit({ subject: 'join_room', details: { token, room } }));
    dispatch({ type: SOCKET_JOIN_ROOM, payload: room });
  };
};

export function leave(token, room) {
  return (dispatch) => {
    dispatch(emit({ subject: 'leave_room', details: { token, room } }));
    dispatch({ type: SOCKET_LEAVE_ROOM, payload: room });
  };
};

export function socketReconnected(token) {
  return (dispatch, getState) => {
    token && token.length > 0 && dispatch(auth(token));

    getState().socket.rooms.forEach((room) => {
      dispatch(join(token, room));
    });
  };
};

export function auth(token) {
  return (dispatch) => {
    dispatch(emit({ subject: 'auth', details: { token }}));
  }
};

export default createReducer(initialState, {
  [SOCKET_CONNECTED]: state => ({
    ...state,
    connected: true,
  }),
  [SOCKET_DISCONNECTED]: state => ({
    ...state,
    connected: false,
  }),
  [SOCKET_JOIN_ROOM]: (state, payload) => {
    const rooms = new Set(state.rooms);
    rooms.add(payload);
    console.log({ rooms: [...rooms] });
    return {
      ...state,
      rooms: [...rooms],
    };
  },
  [SOCKET_LEAVE_ROOM]: (state, payload) => ({
    ...state,
    rooms: state.rooms.filter(room => room !== payload),
  }),
});



// WEBPACK FOOTER //
// ./src/redux/socket.js